import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { ProjectTypeEntryComponent } from './project-type-entry/project-type-entry.component';
import { ProjectTypeListComponent } from './project-type-list/project-type-list.component';

const routes: Routes = [
  { path: 'ProjectTypeEntry', component: ProjectTypeEntryComponent},
  { path: 'ProjectTypes', component: ProjectTypeListComponent}
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class ProjectsRoutingModule { }
